// extracted by mini-css-extract-plugin
export default {"SidebarNotification":"style_SidebarNotification__ctlXm"};